import { Route } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { DcsConfigurationComponent } from './configuration.component';

export const configurationRoute: Route = {
  path: 'dcs-configuration',
  component: DcsConfigurationComponent,
  data: {
    pageTitle: 'configuration.title'
  }
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/configuration/configuration.route.ts